module.exports = __webpack_public_path__ + "img/ad3.4676f621.png";